/**
 * Safely extracts a human-readable error message from an Axios error.
 * FastAPI may return `detail` as a string or as an array of validation error objects.
 * @param {Error} error - The caught error object.
 * @param {string} fallback - Default message to use if no detail is found.
 * @returns {string}
 */
export function getErrorMessage(error, fallback = 'Ha ocurrido un error') {
  const detail = error?.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail[0]?.msg || fallback;
  return fallback;
}
